import React from "react";
import { Button } from "../../stories/Buttons/Button";
import { Modal } from "react-bootstrap";
import exclamationIcon from "../../assets/icons/exclamation_icon.svg";
import { TEST_TYPE_TO_NAME } from "../../utils";

const CancelCurrentAppointment = (props)=> {

    return (
        <div className="row justify-content-center dashboard-page registration-continuous-journey">
        <div className="col-md-12">
            <div className="dashboard">
            <div className="d-flex align-items-center">
                <img
                src={exclamationIcon}
                alt="Exclamation Icon"
                className="exclamation-icon me-3"
                />
                <h1 className="mb-0">Existing Appointment In Progress</h1>
            </div>
            <div className="resume-registration">
                <h4 className="fs-20 ageo-medium text-teal my-0">
                    You may only register for one appointment at a time. Once you have attended your in store appointment you may register for another service.<br/>
                    If you wish to cancel the below registration and continue with your new appointment, select the cancel registration button, or wait until your current appointment has passed before registering again.
                </h4>
                <p className="ageo-regular text-muted mt-4">You’re booked for: <b className="text-teal">{TEST_TYPE_TO_NAME[props.resumeTestType]}</b></p>
                <div className="registration-button-wrapper">
                    <Button
                    className="btn-white"
                    label="Cancel registration"
                    onClick={props.handleRejectBooking}
                    variant="outline"
                    />
                </div>
                <Modal
                    className="confirm-rejection-modal"
                    show={props.modalOpen}
                    onHide={props.toggleModal}
                >
                    <Modal.Header closeButton>
                    <Modal.Title>Confirm Cancellation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                    Are you sure you want to cancel this appointment? This action
                    cannot be undone.
                    </Modal.Body>
                    <Modal.Footer>
                    <Button
                        className="btn-gray"
                        variant={"secondary"}
                        onClick={props.toggleModal}
                        label="Cancel"
                    />
                    <Button
                        className="btn-dark"
                        onClick={props.handleConfirmReject}
                        label="Confirm"
                    />
                    </Modal.Footer>
                </Modal>
                </div>
            </div>
        </div>
        </div>
    );
}

export default CancelCurrentAppointment